import React, { useState } from 'react';
import { Form, FormGroup, Label, Input } from 'reactstrap';

import { InfoText } from 'components/FormComponents/FormComponents';
import { Modal, Header, Body, Footer, FooterButton } from './modalElements';

export default React.memo((props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [issue, setIssue] = useState('');
  const [feedback, setFeedback] = useState('');
  const [hasValidationError, setHasValidationError] = useState(false);

  const hideModal = () => {
    setIsOpen(false);
    return props.confirm({
      isSubmitted: false,
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (!issue) return setHasValidationError(true);
    setIsOpen(false);
    return props.confirm({
      defect: issue,
      feedback: feedback,
      isSubmitted: true,
    });
  };

  const setIssueValue = (value) => {
    if (value) setHasValidationError(false);
    setIssue(value);
  };

  return (
    <Modal isOpen={isOpen}>
      <Header>Report Question</Header>
      <Form onSubmit={submitForm}>
        <Body>
          <FormGroup>
            <Label>Select issue</Label>{' '}
            <Input type="select" name="select" onChange={(e) => setIssueValue(e.target.value)} autoFocus={true}>
              <option value="">Please select a value</option>
              <option>Issue with question</option>
              <option>Issue with options</option>
              <option>Unfit for this test</option>
              <option>Deprecated library/code</option>
              <option>Other</option>
            </Input>
            {hasValidationError && <InfoText error="true">Please select a value</InfoText>}
          </FormGroup>
          <FormGroup>
            <Label>Note</Label>
            <Input
              type="textarea"
              name="text"
              rows="4"
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Add your feedback here"
            />
          </FormGroup>
        </Body>
        <Footer>
          <FooterButton label="Submit Feedback" />
          <FooterButton label="Close" onClick={() => hideModal(false)} />
        </Footer>
      </Form>
    </Modal>
  );
});
